"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearButton = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var Clear_1 = require("./icons/Clear");
var useClearStyles = (0, system_1.makeStyles)(function (theme) { return ({
    root: {
        color: theme.go.schemes.colors.system.IconMinor,
        cursor: 'pointer',
        outline: 'none',
    },
}); });
function ClearButton(_a) {
    var onClick = _a.onClick, className = _a.className;
    var root = useClearStyles().root;
    var preventBlur = (0, react_1.useCallback)(function (e) {
        e.preventDefault();
    }, []);
    return (react_1.default.createElement(Clear_1.ClearIcon, { tabIndex: -1, className: (0, utils_1.cn)(root, className), onClick: onClick, onMouseDown: preventBlur }));
}
exports.ClearButton = ClearButton;
